import axiosOverlay from '../../js/axiosOverlay';

const state = {
    motifs: null
};

const getters = {
    motifs: state => state.motifs,
    getMotifById: (state) => (motifID) => {
        return JSON.parse(state.motifs)?.find(motif => motif.id === motifID) ?? null
    },
    getAllMotifs: (state) => {
        return JSON.parse(state.motifs);
    }
};

const mutations = {
    SET_MOTIFS(state, motifs) {
        state.motifs = motifs;
    }
};

const actions = {
    async loadMotifsFromAPI({ commit, state }) {
        if (state.motifs == null) {
            let config = {
                method: 'get',
                url: process.env.VUE_APP_API_URL + "/sollicitation/motif_clotures",
                headers: { }
            };

            try {
                const response = await axiosOverlay(config);
                let result = JSON.stringify(response.data);
                commit('SET_MOTIFS', result);
            } catch (error) {
                console.log(error);
            }
        }
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
